module.exports = __webpack_public_path__ + "media/images/swines/Pregnant swine with minimal body changes.jpg";